module.exports = __webpack_public_path__ + "img/background7.3fdd8c52.jpg";